import React, { useState, useEffect, useRef } from "react";
import { signupToBlog, createClient } from "../../../lib/helpers";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Hidden, Button, TextField, Checkbox, Icon } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import SanityImage from "gatsby-plugin-sanity-image";
import emailIcon from "./subButton.svg";
import errorIcon from "./errorIcon.svg";
import * as styles from "../../sidebarComponents/sidebar.module.css";
import KeyImage from "./img/key.svg";

import {useStaticQuery, graphql, Link} from "gatsby";
import { isValid } from "date-fns";
import { withStyles } from '@material-ui/core/styles';
import Checked from "../../icon/checked.svg";
import NonChecked from "../../icon/non-checked.svg";
import ReusableCheckbox from "../../landingPageComponents/blocks/reusableCheckbox";
import { emailCaptureSubmissionLogging } from "../../../lib/helpers";


const checkBoxStyles = theme => ({
  root: {
    display: 'inline-block',
    width: '38px',
    padding: '0 !important',
    verticalAlign: 'top',
    '&$checked': {
      color: '#3D70B2',
    },
    '& .MuiIconButton-label': {
      alignItems: 'flex-start',
      justifyContent: 'flex-start'
    },
  },

  checked: {},
});

const iconStyles = theme => ({
  root: {
  }
});

const CustomCheckbox = withStyles(checkBoxStyles)(Checkbox);
const CustomIcon = withStyles(iconStyles)(Icon);

const GetDictionary = () => {
  const data = useStaticQuery(graphql`
    {
      allSanityDictionary(
        filter: { key: { in: ["signup_widget_thank_you_text"] } }
      ) {
        nodes {
          value
          key
        }
      }
    }
  `);

  return data.allSanityDictionary.nodes;
};

const useStyles = makeStyles((theme) => ({
  signUpContainer: {
    background: "#FFF",
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
    border: '0.5px solid #DBE3E',
    filter: 'drop-shadow(0px 2px 4px rgba(64, 64, 64, 0.1))'
  },
  signUpTopRow: {
    borderTopLeftRadius: '12px',
    borderTopRightRadius: '12px',
    background: '#3C465F',
    padding: '8px'
  },
  signUpImageContainer: {
    [theme.breakpoints.up("md")]: {
      padding: "29px 24px 29px 24px",
      display: "none",
    },
    [theme.breakpoints.up("lg")]: {
      display: "flex",
    },
  },
  signUpImage: {
    height: "100%",
    width: "100%",
    borderRadius: "8px 8px 0 0",
    objectFit: "cover",
    [theme.breakpoints.up("md")]: {
      borderRadius: "8px",
    },
  },
  textButtonInputContainer: {
    padding: "1rem",
    [theme.breakpoints.up("md")]: {
      padding: "1rem 1rem 2.5rem 1rem",
    },
    [theme.breakpoints.up("lg")]: {
    },
    flexBasis: '67%',
    maxWidth: '67%',
    [theme.breakpoints.down(1400)]: {
      flexBasis: '81%',
      maxWidth: '81%',
    },
    [theme.breakpoints.down(751)]: {
      flexBasis: '100%',
      maxWidth: '100%',
    }
  },
  titleAndParaHolder: {
    marginBottom: "1.5rem",
    marginTop: '32px',
    [theme.breakpoints.up("md")]: {
      marginBottom: "1rem",
    },
    [theme.breakpoints.up("lg")]: {
      marginBottom: "1.5rem",
    },
    [theme.breakpoints.down(600)]: {
      marginTop: 'initial'
    }
  },
  justParaHolder: {
    marginBottom: "1.5rem",
    [theme.breakpoints.up("md")]: {
      marginBottom: "1rem",
    },
    [theme.breakpoints.up("lg")]: {
      marginBottom: "1.5rem",
    },
    [theme.breakpoints.down(600)]: {
      marginTop: 'initial'
    }
  },
  titleAndParaHolderNoText: {
    marginTop: "40px",
    height: 0,
    // [theme.breakpoints.up("md")]: {
    //   marginBottom: "1rem",
    // },
    // [theme.breakpoints.up("lg")]: {
    //   marginBottom: "1.5rem",
    // },
    [theme.breakpoints.down(600)]: {
      marginTop: '16px'
    }
  },
  inputField: {
    width: "100%",
    height: "52px",
    background: "#F5F7FA",
    boxShadow: "inset 0px 2px 2px -1px rgba(74, 74, 104, 0.1)",
    borderRadius: "8px",
    "& > div": {
      fontSize: "14px",
      height: "100%",
      "&::before": {
        borderBottom: "none !important",
      },
    },
    "& input": {
      paddingLeft: "1rem",
      paddingRight: "1rem",
    },
    border: '0.5px solid #DBE3EF'
  },
  buttonContainer: {
    marginTop: "16px",
  },
  buttonContainerError: {
    marginTop: "1rem",
    [theme.breakpoints.down("sm")]: {
      marginTop: "1rem",
      paddingTop: "0",
    },
    [theme.breakpoints.up("md")]: {
      marginTop: 0,
      paddingLeft: 8,
    },
  },
  submitButton: {
    background: "#FF0F5F",
    color: "white",
    textTransform: "uppercase",
    width: "100%",
    height: "52px",
    borderRadius: "8px",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.04)",
    "&:hover": {
      background: "#FF0F5F",
      color: "white",
    },
    "&:focus": {
      background: "#FF0F5F",
      color: "white",
    },
    "&:active": {
      background: "#FF0F5F",
      color: "white",
    },
    [theme.breakpoints.up("md")]: {
      paddingLeft: "1rem",
      paddingRight: "1rem",
    },
    [theme.breakpoints.up("lg")]: {
      paddingLeft: "1.5rem",
    },
  },
  submitIcon: {
    paddingRight: "9px",
    verticalAlign: 'middle',
    marginTop: '-3px'
  },
  inputError: {
    boxShadow: "inset 0px 2px 2px -1px rgba(74, 74, 104, 0.1)",
    border: "#FF0F5F 1px solid",
    borderRadius: "8px",
    color: "white",
  },
  subscribedContainer: {
    padding: "1rem",
  },
  paragraphText: {
    color: "white",
  },
  errorText: {
    position: "relative",
    bottom: "16px",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    display: "inline-flex",
    paddingTop: "8px",
    width: "100%",
    color: "#2F2F4E",
    marginTop: '16px'
  },
  errorIcon: {
    height: "16px",
    width: "16px",
  },
  bodyText: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#2F2F4E",
    display: 'block',
    textAlign: 'center'
  },
  holderForParaOnly: {
    paddingTop: "4px",
  },
  checkboxSpan: {
    display: 'inline-block',
    width: 'calc(100% - 38px)',
    cursor: 'pointer',
  },
  marketingConsentContainer: {
    marginTop: '16px',
    marginBottom: '24px',
    [theme.breakpoints.down(600)]: {
      marginBottom: 'initial'
    }
  },
  titleLabel: {
    color: 'white !important'
  },
  subscribeLabel: {
    color: '#FFF !important',
    letterSpacing: '0.01em',
    fontSize: '18px',
    lineHeight: '32px',
    fontWeight: 600
  },
  title: {
    display: 'block',
    textAlign: 'center',
    [theme.breakpoints.down(600)]: {
      fontSize: '20px',
      lineHeight: '28px'
    }
  },
  checkboxContainer:{
    display: "flex",
  },
  linkText:{
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    textDecoration: "none",
    color: "#0070EA",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  loginContainer:{
    textAlign: "center",
    [theme.breakpoints.down("md")]:{
      paddingTop: "16px",
    },
  },
}));

const BlueHeadingWithKeyEmailSignupWidget = ({
  title,
  image,
  paragraphText,
  buttonText,
  textboxPlaceholder,
  subscribedCallback,
  brazeCustomAttributes,
  textNextToKey,
}) => {
  const [state, setState] = useState({
    username: "",
    errors: {},
    formIsValid: false,
    isSubmitted: false,
    isToggleOn: true,
    marketingConsent: false
  });

  const [logGA, setLogGA] = useState(false);
  const classes = useStyles();

  const holderEl = useRef(null);

  const initialiseThankYou = async () => {
    const result = await getSignupThankYouText();
    setState((state) => ({ ...state, thankYouText: result[0].value }));
  };

  useEffect(() => {
    initialiseThankYou();
  }, []);

  useEffect(() => {
    if (state.isSubmitted && window.dataLayer) {
      window.dataLayer.push({ event: "subscribe_form_submitted" });
    }
  }, [state]);


  useEffect(() => {
    (async () => {
      if (logGA) emailCaptureSubmissionLogging()
    })();
  }, [logGA]);

  const handleUsername = (event) => {
    let errors = {};
    let formIsValid = true;
    let field = event.target.value;

    setState((state) => ({
      ...state,
      username: event.target.value,
      errors: errors,
      formIsValid: formIsValid,
    }));
  };

  const submitted = (event) => {
    let formIsValid = state.formIsValid;
    let userName = state.username;
    let errors = {};

    if (typeof state.formIsValid == "undefined") {
      formIsValid = false;
      errors["empty"] = "Field is empty";
      setState((state) => ({ ...state, errors: errors }));
    }

    const emailRegex = /^[\w\-.+]+@([\w-]+\.)+[\w-]{2,4}$/g;

    if (typeof state.formIsValid !== "undefined") {
      let lastAtPos = userName.lastIndexOf("@");
      let lastDotPos = userName.lastIndexOf(".");

      if (!userName.match(emailRegex)) {
        formIsValid = false;
        errors["email"] = "Email is invalid";
        setState((state) => ({ ...state, errors: errors }));
      }
    }

    event.preventDefault();

    if (formIsValid) {
      //signupToBlog(state.username);
      setLogGA(true);
      if (brazeCustomAttributes && brazeCustomAttributes[0]?.customAttributeKey){
        localStorage.setItem('custom_attr', btoa(brazeCustomAttributes[0].customAttributeKey + "|" + brazeCustomAttributes[0].customAttributeValue));
      }
      const hash = window.location.hash
      localStorage.setItem("hash", hash)
      localStorage.setItem("genMkt", state.marketingConsent)
      window.location.href =
        "/login?returnUrl=" +
        encodeURIComponent(`${window.location.pathname}${hash ? hash : ""}`) +
        "&usr=" +
        btoa(state.username);

      return null;

      //window.signup(state.username, brazeSubscriptionRefGate, state.marketingConsent, brazeCustomAttributes);

      //subscribedCallback();

      //setState((state) => ({
      //  ...state,
      //  isToggleOn: !state.isToggleOn,
      //  isSubmitted: true,
      //}));
    } else {
      holderEl.current.className =
        holderEl.current.className + ` ${classes.inputError}`;
      //console.log("formIsValid", formIsValid);
    }
  };

  const getSignupThankYouText = async function () {
    var params = {};

    var query =
      "*[_type == 'dictionary'][key match ['signup_widget_thank_you_text']]";

    return createClient()
      .fetch(query, params)
      .then((response) => response)
      .then((responseJson) => {
        return responseJson;
      });
  };

  const handleChange = (event) => {
    setState({ ...state, marketingConsent: event.target.checked });
  };

  return (
    <>
      <Grid container alignItems="center" justifyContent="center" className={classes.signUpTopRow}>
        <Typography variant="h4" className={classes.subscribeLabel}>
          <img src={KeyImage} className={classes.submitIcon} />
          {textNextToKey}
        </Typography>
      </Grid>
      <Grid
        container
        className={classes.signUpContainer}
        alignItems={"center"}
        justifyContent="center"
      >
        <>
          <Grid
            container
            xs={12}
            sm={12}
            md={12}
            lg={7}
            className={classes.textButtonInputContainer}
          >
            <Grid container className={title && paragraphText || title && !paragraphText ? classes.titleAndParaHolder : !title && paragraphText ? classes.justParaHolder : classes.titleAndParaHolderNoText} alignItems="center" justifyContent="center">
              <Grid item>
                <Typography variant="h2" className={classes.title}>
                  {state.isToggleOn ? title : state.thankYouText}
                </Typography>
              </Grid>
              <Grid item className={classes.holderForParaOnly}>
                <Typography variant="body-2" className={classes.bodyText}>
                  {state.isToggleOn
                    ? paragraphText
                    : "Subscription confirmation sent to the specified e-mail You’ll start receiving free tips and resources soon."}
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              {state.isToggleOn ? (
                <TextField
                  ref={holderEl}
                  id="emailField"
                  className={classes.inputField}
                  placeholder="Enter your email address..."
                  value={state.username}
                  onChange={handleUsername}
                />
              ) : null}
            </Grid>

            {state.errors && Object.keys(state.errors).length > 0 ? (
              <span className={classes.errorText}>
                <img
                  className={classes.errorIcon}
                  src={errorIcon}
                  alt="error"
                />
                &nbsp;Please enter a valid email address{" "}
              </span>
            ) : null}

            {state.isToggleOn && (
              <Grid
                item
                xs={12}

                className={
                  state.errors && Object.keys(state.errors).length > 0
                    ? classes.buttonContainerError
                    : classes.buttonContainer
                }
              >
                <Button className={classes.submitButton} onClick={submitted}>
                  <img src={emailIcon} className={classes.submitIcon} />
                  {buttonText}
                </Button>
              </Grid>
            )}

            <Grid item xs={12} className={classes.marketingConsentContainer}>
              {state.isToggleOn ? (
                <label className={classes.checkboxContainer}>
                  <ReusableCheckbox checked={state.marketingConsent} handleChange={handleChange} />
                  <span className={classes.checkboxSpan}>
                    I would like to hear from you about products, events, general
                    marketing and other things from Boring Money – including
                    personalised content and ads - but please try not to make them
                    as boring as everything else in finance!
                </span>
                </label>
              ) : null}
            </Grid>
            <Grid item xs={12} className={classes.loginContainer}>
              <Typography variant={"body1"}>
                Already have an account? <a href={"/login"} className={classes.linkText}>Login</a></Typography>
            </Grid>
          </Grid>
        </>
      </Grid>
    </>
  );
};

export default BlueHeadingWithKeyEmailSignupWidget;
